/* @flow */

import React, { Component } from 'react';
import pure from 'recompose/pure';

type Props = {
  className: string,
  folder: BucketFolder,
  onUpload: (files: FileList) => void,
};

const styles = {
  input: {
    display: 'none',
  },
};

class UploadFileButton extends Component {
  props: Props;

  fileInput: any;

  onSelectFile = (event: SyntheticEvent) => {
    event.stopPropagation();

    this.fileInput.click();
  };

  onFileSelected = (event: SyntheticEvent) => {
    const { onUpload } = this.props;

    if (event.target instanceof HTMLInputElement) {
      const files = event.target.files;
      onUpload(files);
    }
  };

  render() {
    const { className } = this.props;

    return (
      <div className={className} onClick={this.onSelectFile}>
        <input
          type="file"
          name="upload"
          multiple
          onChange={this.onFileSelected}
          style={styles.input}
          ref={input => {
            this.fileInput = input;
          }}
        />
        Ajouter
      </div>
    );
  }
}

export default pure(UploadFileButton);



// WEBPACK FOOTER //
// ./src/modules/bucket/screens/Folders/components/UploadFileButton.js